(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-popup"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dgf-featured-product"]) return;
  try {
    
  // DGF Featured Product - Modular JavaScript with Error Handling
  (function() {
    'use strict';

    let selectedVariantId = null;
    let productData = null;

    // Get product data from JSON script tag
    try {
      const productDataElement = document.getElementById('dgf-product-data');
      if (productDataElement) {
        productData = JSON.parse(productDataElement.textContent);
      }
    } catch(e) {
      console.error('❌ Error parsing product data:', e);
    }

    // Function: Remove 6-Pack variants
    function remove6PackVariants() {
      try {
        const variantCards = document.querySelectorAll('.dgf-option-card');
        variantCards.forEach(card => {
          try {
            const title = card.querySelector('.dgf-option-title')?.textContent || '';
            if (title.includes('6-Pack')) {
              card.remove();
            }
          } catch(e) { null; }
        });
      } catch(e) { null; }
    }

    // Function: Initialize Gallery Swipers
    function initializeGallerySwipers() {
      try {
        const thumbnailWrapper = document.querySelector('.thumbnail-gallery .swiper-wrapper');
        const thumbnailSlides = thumbnailWrapper ? thumbnailWrapper.children.length : 0;

        // Initialize Thumbnail Gallery
        const thumbnailGallery = new Swiper('.thumbnail-gallery', {
          spaceBetween: 10,
          slidesPerView: 4,
          watchSlidesProgress: true,
          loop: thumbnailSlides > 4,
          navigation: {
            nextEl: '.product-thumbnail-next',
            prevEl: '.product-thumbnail-prev',
          },
          slideToClickedSlide: true,
        });

        // Initialize Main Gallery
        const mainGallery = new Swiper('.main-gallery', {
          spaceBetween: 10,
          navigation: {
            nextEl: '.product-gallery-next',
            prevEl: '.product-gallery-prev',
          },
          thumbs: {
            swiper: thumbnailGallery,
          },
          loop: true,
        });

        setupGallerySynchronization(thumbnailGallery, mainGallery);
        setupThumbnailNavigation(thumbnailGallery, thumbnailSlides);

        return { thumbnailGallery, mainGallery };
      } catch(e) { null; }
    }

    // Function: Setup Gallery Synchronization
    function setupGallerySynchronization(thumbnailGallery, mainGallery) {
      try {
        thumbnailGallery.on('slideChangeTransitionEnd', function () {
          try {
            const activeIndex = thumbnailGallery.realIndex;
            mainGallery.slideToLoop(activeIndex, 0);
          } catch(e) { null; }
        });

        mainGallery.on('slideChangeTransitionEnd', function () {
          try {
            const activeIndex = mainGallery.realIndex;
            thumbnailGallery.slideToLoop(activeIndex, 0);
          } catch(e) { null; }
        });
      } catch(e) { null; }
    }

    // Function: Setup Thumbnail Navigation
    function setupThumbnailNavigation(thumbnailGallery, thumbnailSlides) {
      try {
        const prevArrow = document.querySelector('.product-thumbnail-prev');
        const nextArrow = document.querySelector('.product-thumbnail-next');

        if (!prevArrow || !nextArrow) return;

        if (thumbnailSlides <= 4) {
          prevArrow.style.display = 'none';
          nextArrow.style.display = 'none';
        } else {
          thumbnailGallery.on('slideChange', function () {
            try {
              prevArrow.style.display = 'block';
              nextArrow.style.display = 'block';

              if (thumbnailGallery.isBeginning) {
                prevArrow.classList.add('swiper-button-disabled');
              } else {
                prevArrow.classList.remove('swiper-button-disabled');
              }

              if (thumbnailGallery.isEnd) {
                nextArrow.classList.add('swiper-button-disabled');
              } else {
                nextArrow.classList.remove('swiper-button-disabled');
              }
            } catch(e) { null; }
          });
        }
      } catch(e) { null; }
    }

    // Function: Update Price Display
    function updatePriceDisplay(price, comparePrice) {
      try {
        // Convert to numbers - handle empty strings and null
        const priceNum = parseInt(price) || 0;
        const comparePriceNum = comparePrice && comparePrice !== '' ? parseInt(comparePrice) : 0;

        const priceDisplay = document.getElementById('selected-price');
        const buttonPrice = document.getElementById('button-price');
        const comparePriceDisplay = document.getElementById('compare-price');


        if (priceDisplay && priceNum) {
          priceDisplay.textContent = '$' + (priceNum / 100).toFixed(2);
        }

        if (buttonPrice && priceNum) {
          buttonPrice.textContent = '$' + (priceNum / 100).toFixed(2);
        }

        if (comparePriceDisplay) {
          if (comparePriceNum > 0 && comparePriceNum > priceNum) {
            comparePriceDisplay.textContent = '$' + (comparePriceNum / 100).toFixed(2);
            comparePriceDisplay.style.display = 'inline';
          } else {
            comparePriceDisplay.style.display = 'none';
          }
        }
      } catch(e) {
        console.error('❌ Error updating price display:', e);
      }
    }

    // Function: Select Variant
    function selectVariantById(variantId, price, comparePrice) {
      try {
        selectedVariantId = variantId;
        updatePriceDisplay(price, comparePrice);
      } catch(e) { null; }
    }

    // Function: Setup Variant Selection
    function setupVariantSelection() {
      try {
        const variantCards = document.querySelectorAll('.dgf-variant-card');
        if (variantCards.length === 0) return;

        // Set initial selected variant
        const firstSelected = document.querySelector('.dgf-variant-card.selected');
        if (firstSelected) {
          selectedVariantId = firstSelected.dataset.variantId;
        } else {
          const firstAvailable = Array.from(variantCards).find(card => {
            try {
              const title = card.querySelector('.dgf-option-title')?.textContent || '';
              return !title.includes('6-Pack');
            } catch(e) { return false; }
          });

          if (firstAvailable) {
            firstAvailable.classList.add('selected');
            selectedVariantId = firstAvailable.dataset.variantId;
          }
        }

        // Add click event listeners
        variantCards.forEach(card => {
          try {
            card.addEventListener('click', function() {
              try {
                // Remove selected from all cards
                variantCards.forEach(c => c.classList.remove('selected'));

                // Add selected to clicked card
                this.classList.add('selected');

                // Update variant and prices
                const variantId = this.dataset.variantId;
                const price = this.dataset.variantPrice;
                const comparePrice = this.dataset.variantComparePrice;

                selectVariantById(variantId, price, comparePrice);
              } catch(e) { null; }
            });
          } catch(e) { null; }
        });
      } catch(e) { null; }
    }

    // Function: Setup Variant Radio Listeners
    function setupVariantRadioListeners() {
      try {
        const variantRadios = document.querySelectorAll('.dgf-variant-radio');
        variantRadios.forEach(radio => {
          radio.addEventListener('change', function() {
            if (this.checked) {
              updatePackOptions(this.value);
            }
          });
        });

        // No need to trigger initial filter - Liquid already renders only the default variant cards
        console.log('✅ Variant radio listeners setup complete');
      } catch(e) {
        console.error('❌ Error setting up variant radio listeners:', e);
      }
    }

    // Function: Setup Add to Cart Button
    function setupAddToCartButton() {
      try {
        const addToCartBtn = document.getElementById('add-to-cart-btn');
        if (addToCartBtn) {
          addToCartBtn.addEventListener('click', function(e) {
            e.preventDefault();
            addToCart();
          });
        }
      } catch(e) {
        console.error('❌ Error setting up add to cart button:', e);
      }
    }

    // Function: Add to Cart
    function addToCart() {
      try {
        if (!selectedVariantId) {
          console.error('No variant selected');
          return;
        }

        const button = document.getElementById('add-to-cart-btn');

        // Disable button
        if (button) {
          button.disabled = true;
          button.textContent = 'ADDING...';
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{ id: selectedVariantId, quantity: 1 }]
          })
        })
        .then(response => response.json())
        .then(data => {
          try {
            if (data.items && data.items.length > 0) {
              handleCartSuccess(data);
            } else {
              console.error('Error adding product to cart');
            }
          } catch(e) { null; }
        })
        .catch(error => {
          console.error('Error adding product to cart:', error);
        })
        .finally(() => {
          try {
            if (button) {
              button.disabled = false;
              button.textContent = 'ADD TO CART';
            }
          } catch(e) { null; }
        });
      } catch(e) { null; }
    }

    // Function: Handle Cart Success
    function handleCartSuccess(data) {
      try {
        // Update cart count
        if (typeof updateCartCount === 'function') {
          updateCartCount();
        }

        // Open cart drawer
        const cartDrawer = document.querySelector('[data-cart-drawer]') ||
                          document.querySelector('.cart-drawer') ||
                          document.querySelector('#cart-drawer');

        if (cartDrawer) {
          if (typeof openCartDrawer === 'function') {
            openCartDrawer();
          } else if (cartDrawer.classList) {
            cartDrawer.classList.add('active', 'open');
          }
        } else {
          console.log('Product added to cart successfully');
        }

        // Dispatch cart update event
        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: { items: data.items }
        }));
      } catch(e) { null; }
    }

    // Function: Update Pack Options Based on Variant Selection
    function updatePackOptions(selectedValue) {
      try {
        console.log('🔄 Updating pack options for variant:', selectedValue);

        // Check if product data is available
        if (!productData) {
          console.error('❌ Product data not available');
          return;
        }

        // Get all product variants
        const allVariants = productData.variants || [];

        // Filter variants that match the selected option value and exclude 6-Pack
        const matchingVariants = allVariants.filter(variant => {
          const title = variant.title || '';
          return title.includes(selectedValue) && !title.includes('6-Pack') && variant.available;
        });

        console.log('✅ Found matching variants:', matchingVariants.length);

        // Get the variant cards container
        const variantOptionsContainer = document.querySelector('.dgf-variant-options');
        if (!variantOptionsContainer) {
          console.error('❌ Variant options container not found');
          return;
        }

        // Clear existing cards
        variantOptionsContainer.innerHTML = '';

        // Create new cards for matching variants
        matchingVariants.forEach((variant, index) => {
          const card = createVariantCard(variant, index, matchingVariants.length);
          variantOptionsContainer.appendChild(card);
        });

        // Re-setup variant selection
        setupVariantSelection();

        // Auto-select the "Most Popular" card (index 1) or first card if less than 2
        const newCards = variantOptionsContainer.querySelectorAll('.dgf-variant-card');
        if (newCards.length > 0) {
          const cardToSelect = newCards.length > 1 ? newCards[1] : newCards[0];
          if (cardToSelect) {
            // Trigger click to select and update prices
            cardToSelect.click();

            // Force update prices immediately after click
            const variantId = cardToSelect.dataset.variantId;
            const price = cardToSelect.dataset.variantPrice;
            const comparePrice = cardToSelect.dataset.variantComparePrice;

            console.log('🔄 Auto-selected card:', {
              variantId,
              price,
              comparePrice: comparePrice || 'none'
            });

            // Ensure prices are updated
            updatePriceDisplay(price, comparePrice);
          }
        }

        console.log('✅ Pack options updated successfully');

      } catch(e) {
        console.error('❌ Error updating pack options:', e);
      }
    }

    // Function: Create Variant Card
    function createVariantCard(variant, index, totalVariants) {
      try {
        const card = document.createElement('div');
        card.className = 'dgf-option-card dgf-variant-card';

        // Add selected class to "Most Popular" (index 1)
        if (index === 1) {
          card.classList.add('selected', 'dgf-most-popular');
        }

        card.setAttribute('data-variant-id', variant.id);
        card.setAttribute('data-variant-price', variant.price);
        card.setAttribute('data-variant-compare-price', variant.compare_at_price || '');

        // Determine header text and background
        let headerText = '';
        let headerBg = '';
        if (index === 0) {
          headerText = 'DAILY SAVINGS<br>25% OFF';
          headerBg = '#06211E';
        } else if (index === 1) {
          headerText = 'MOST POPULAR<br>30% OFF';
          headerBg = '#AC853B';
        } else if (index === 2) {
          headerText = 'BEST VALUE<br>35% OFF';
          headerBg = '#06211E';
        }

        // Calculate pack size
        let packSize = 1;
        const title = variant.title;
        if (title.includes('2-Pack')) packSize = 2;
        else if (title.includes('3-Pack')) packSize = 3;
        else if (title.includes('4-Pack')) packSize = 4;
        else if (title.includes('5-Pack')) packSize = 5;

        // Calculate prices
        const pricePerPack = variant.price / packSize / 100;

        // Get servings from metafields
        const servings = variant.metafields?.custom?.lp_qty_servings;
        const pricePerServing = variant.metafields?.custom?.lp_prc_servings;

        // Build card HTML
        card.innerHTML = `
          <div class="dgf-option-header" style="background-color: ${headerBg};">
            ${headerText}
          </div>
          <div class="dgf-option-content">
            <div class="dgf-option-top">
              <div class="dgf-option-title">${title}</div>
              <div class="dgf-option-price-wrapper">
                <div class="dgf-option-price">$${pricePerPack.toFixed(2)}</div>
                <div class="dgf-option-each" ${packSize === 1 ? 'style="opacity: 0;"' : ''}>(each)</div>
              </div>
            </div>
            <div class="dgf-option-bottom">
              <div class="dgf-option-servings">${servings} servings</div>
              <div class="dgf-option-per-serving">(<strong>$${pricePerServing}</strong>/serving)</div>
            </div>
          </div>
        `;

        return card;
      } catch(e) {
        console.error('❌ Error creating variant card:', e);
        return document.createElement('div');
      }
    }

    // Initialize on DOMContentLoaded
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    function init() {
      try {
        remove6PackVariants();
        initializeGallerySwipers();
        setupVariantSelection();
        setupVariantRadioListeners();
        setupAddToCartButton();
      } catch(e) {
        console.log('❌ DGF Featured Product: Error in initialization', e);
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dgf-img-and-accordion"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Make toggleAccordion function global
  window.toggleAccordion = function(header) {
    try {
      const content = header.nextElementSibling;
      const isActive = content.classList.contains('active');

      // Close all accordions in this section
      const sectionId = header.closest('section').id;
      const allContents = document.querySelectorAll(`#${sectionId} .dgf-accordion-content`);
      const allHeaders = document.querySelectorAll(`#${sectionId} .dgf-accordion-header`);

      allContents.forEach(item => item.classList.remove('active'));
      allHeaders.forEach(item => item.classList.remove('active'));

      // Open current accordion if it wasn't active
      if (!isActive) {
        content.classList.add('active');
        header.classList.add('active');
      }
    } catch(e) {
      console.error('Accordion toggle error:', e);
    }
  };
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dgf-img-and-text"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  try {
    if (window.innerWidth <= 767) {
      const mobileButton = document.querySelector('.dgf-mobile-button-wrapper');
      if (mobileButton) {
        let buttonOriginalPosition = mobileButton.offsetTop;
        let isSticky = false;

        // Get button URL and check if it's an internal section link
        const buttonLink = mobileButton.querySelector('a');
        let targetSectionId = null;

        if (buttonLink && buttonLink.href) {
          const href = buttonLink.getAttribute('href');
          // Check if href contains shopify-section pattern
          if (href.includes('#dgf-featured-product')) {
            targetSectionId = 'dgf-featured-product';
          }
        }

        function isInTargetSection() {
          try {
            if (!targetSectionId) return false;

            // Find the target section element
            const targetSection = document.getElementById(targetSectionId);
            if (!targetSection) return false;

            // Get exact section boundaries - no buffer
            const sectionTop = targetSection.offsetTop;
            const sectionBottom = targetSection.offsetTop + targetSection.offsetHeight;
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const windowHeight = window.innerHeight;
            const viewportTop = scrollTop;
            const viewportBottom = scrollTop + windowHeight;

            // Check if viewport overlaps with the exact section boundaries
            return viewportBottom >= sectionTop && viewportTop <= sectionBottom;
          } catch(e) {
            return false;
          }
        }

        let scrollTimeout;
        function handleScroll() {
          try {
            // Clear previous timeout to prevent rapid fire
            clearTimeout(scrollTimeout);

            scrollTimeout = setTimeout(() => {
              const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
              const shouldBeSticky = scrollTop > buttonOriginalPosition + 100;
              const inTargetSection = isInTargetSection();

              // Show sticky button only if should be sticky AND not in target section
              if (shouldBeSticky && !inTargetSection && !isSticky) {
                mobileButton.classList.add('dgf-mobile-sticky-button');
                isSticky = true;
              } else if ((!shouldBeSticky || inTargetSection) && isSticky) {
                mobileButton.classList.remove('dgf-mobile-sticky-button');
                isSticky = false;
              }
            }, 10); // Small delay to prevent rapid changes
          } catch(e) { null; }
        }

        window.addEventListener('scroll', handleScroll);

        // Recalculate position if window is resized
        window.addEventListener('resize', function() {
          try {
            if (window.innerWidth <= 767) {
              buttonOriginalPosition = mobileButton.offsetTop;
            } else {
              mobileButton.classList.remove('dgf-mobile-sticky-button');
              isSticky = false;
            }
          } catch(e) { null; }
        });
      }
    }
  } catch(e) { null; }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dgf-subscribe-benefits"] && !Shopify.designMode) return;
  try {
    
const carouselConfig = {
  slidesPerView: 3,
  spaceBetween: 10,
  loop: true,
  centeredSlides: false,
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  },
  freeMode: false,
  watchSlidesProgress: true,
  breakpoints: {
    0: {
      slidesPerView: 3,
      spaceBetween: 8,
    },
    480: {
      slidesPerView: 3,
      spaceBetween: 10,
    },
    640: {
      slidesPerView: 3,
      spaceBetween: 10,
    }
  }
};


function isMobile() {
  try {
    return window.innerWidth <= 767;
  } catch (e) { null; }
}


function carouselExists() {
  try {
    const carouselElement = document.querySelector('#benefits-carousel');
    return carouselElement && carouselElement.swiper;
  } catch (e) { null; }
}


function initializeCarousel() {
  try {
    const carouselElement = document.querySelector('#benefits-carousel');
    
    if (!carouselElement) {
      return null;
    }

    if (typeof Swiper === 'undefined') {
      return null;
    }

    const carousel = new Swiper('#benefits-carousel', carouselConfig);
    return carousel;
    
  } catch (e) { null; }
}

function destroyCarousel() {
  try {
    const carouselElement = document.querySelector('#benefits-carousel');
    
    if (carouselElement && carouselElement.swiper) {
      carouselElement.swiper.destroy(true, true);
    }
  } catch (e) { null; }
}

function handleCarouselResize() {
  try {
    if (isMobile()) {
      if (!carouselExists()) {
        initializeCarousel();
      }
    } else {
      if (carouselExists()) {
        destroyCarousel();
      }
    }
  } catch (e) { null; }
}


function initializeMobileCarousel() {
  try {
    if (isMobile()) {
      initializeCarousel();
    }
    } catch (e) { null; }
}


function setupEventListeners() {
  try {
    window.addEventListener('resize', handleCarouselResize);
    window.addEventListener('resize', handleResponsiveScale);
  } catch (error) {null; }
}

// Função para controle dinâmico de escala
function handleResponsiveScale() {
  try {
    const windowWidth = window.innerWidth;
    const benefitsContainer = document.querySelector('#id-{{ section.id }} .benefits-container');
    
    if (!benefitsContainer) return;
    
    // Aplica escala dinâmica apenas entre 1024px e 1280px
    if (windowWidth >= 1024 && windowWidth <= 1280) {
      const benefitItems = benefitsContainer.querySelectorAll('.benefit-item');
      const benefitArrows = benefitsContainer.querySelectorAll('.benefit-arrow');
      const totalItems = benefitItems.length;
      
      if (totalItems === 0) return;
      
      // Calcula a escala baseada na largura disponível
      const containerPadding = 60; // padding das laterais + margem extra
      const availableWidth = windowWidth - containerPadding;
      const minItemWidth = 185; // largura mínima por item (aumentada para considerar setas)
      const arrowWidth = 41; // largura da seta + margens (20px + 2px + 19px margin)
      const totalArrowWidth = benefitArrows.length * arrowWidth;
      const idealTotalWidth = (totalItems * minItemWidth) + totalArrowWidth;
      
      let scale = 1;
      if (idealTotalWidth > availableWidth) {
        scale = Math.max(0.70, availableWidth / idealTotalWidth);
      }
      
      // Aplica a escala calculada
      benefitsContainer.style.transform = `scale(${scale})`;
      
      // Ajusta o container para evitar overflow
      if (scale < 1) {
        benefitsContainer.style.marginTop = `${(1 - scale) * -25}px`;
        benefitsContainer.style.marginBottom = `${(1 - scale) * -25}px`;
      }
      
    } else {
      // Remove transformações para outras resoluções
      benefitsContainer.style.transform = '';
      benefitsContainer.style.marginTop = '';
      benefitsContainer.style.marginBottom = '';
    }
  } catch (error) {
    console.warn('Erro no controle de escala responsiva:', error);
  }
}

// Função para inicializar o controle de escala
function initResponsiveScale() {
  try {
    handleResponsiveScale();
  } catch (error) {
    console.warn('Erro ao inicializar controle de escala:', error);
  }
}


function init() {
  try {
    initializeMobileCarousel();
    initResponsiveScale();
    setupEventListeners();
  } catch (e) { null; }
}

document.addEventListener('DOMContentLoaded', init);

  } catch(e) { console.error(e); }
})();
})();
